interface ScheduleButtonDisabledParams {
  disabled: boolean;
  routesLength: number;
  orderAssignedToOnlyRoute: boolean;
  allOrdersAssignedToRoute: boolean;
  hasPermission: boolean;
  hasCompleted: boolean;
  hasArrivedStop: boolean;
}

/**
 * Determine if the schedule button should be disabled
 * 
 * @param params - Object containing all relevant state for determining disabled status
 * @returns true if the button should be disabled, false otherwise
 */
const isScheduleButtonDisabled = ({
  disabled,
  orderAssignedToOnlyRoute,
  allOrdersAssignedToRoute,
  hasPermission,
  hasCompleted,
  hasArrivedStop,
}: ScheduleButtonDisabledParams): boolean => {
  return (
    disabled ||
    orderAssignedToOnlyRoute ||
    allOrdersAssignedToRoute ||
    !hasPermission ||
    hasCompleted ||
    hasArrivedStop
  );
};

export default isScheduleButtonDisabled;
